import React, { ReactNode } from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Button from '@components/UI-KIT/Button';
import { More, Write } from '@/assets/icons';
import Divider from '@components/UI-KIT/Divider';
import AccountFormStepper from '@components/Accounts/AccountFormStepper';
import TransactionFormStepper from '@components/Accounts/TransactionFormStepper';

// Styles
import VARIABLES from '@/assets/variables.ts';

interface Props {
    setDrawer: React.Dispatch<React.SetStateAction<{
        drawerOpened: boolean;
        drawerTitle: string;
        drawerChildren: ReactNode;
        drawerFooter: boolean;
        titleIcon: ReactNode;
    }>>;
    handleFetchOrganizationAccounts: () => void;
    handleFetchHeroData: () => void;
    handleFetchAccountTransactions: () => void;
}

const AccountsHeader: React.FC<Props> = ({
    setDrawer,
    handleFetchHeroData,
    handleFetchOrganizationAccounts,
    handleFetchAccountTransactions
}) => {

    return (
        <>
            <Typography
                variant="h3"
                color="primary-dark"
                className="AOL-Header-title"
            >
                Cuentas
            </Typography>
            <Grid
                item
                container
                justify="flex-end"
                alignItems="center"
            >
                <Button
                    label="Agregar cuenta"
                    level={1}
                    icon={(
                        <More
                            color={VARIABLES.palette.secondary_color}
                        />
                    )}
                    onClick={() => setDrawer({
                        drawerOpened: true,
                        drawerTitle: 'Agregar cuenta',
                        titleIcon: null,
                        drawerChildren: (
                            <AccountFormStepper
                                setDrawer={setDrawer}
                                handleFetchHeroData={handleFetchHeroData}
                                handleFetchOrganizationAccounts={handleFetchOrganizationAccounts}
                            />
                        ),
                        drawerFooter: true
                    })}
                />
                <Divider
                    orientation="vertical"
                />
                <Button
                    label="Nueva transacción"
                    level={1}
                    icon={(
                        <Write
                            color={VARIABLES.palette.secondary_color}
                        />
                    )}
                    onClick={() => setDrawer({
                        drawerOpened: true,
                        drawerTitle: 'Nueva transacción',
                        titleIcon: null,
                        drawerChildren: (
                            <TransactionFormStepper
                                setDrawer={setDrawer}
                                handleFetchHeroData={handleFetchHeroData}
                                handleFetchOrganizationAccounts={handleFetchOrganizationAccounts}
                                handleFetchAccountTransactions={handleFetchAccountTransactions}
                            />
                        ),
                        drawerFooter: true
                    })}
                />
            </Grid>
        </>
    );
};

export default AccountsHeader;